
import type { AppMessages, ContextState } from '../models'
import { computed, defineComponent, getCurrentInstance } from 'vue'
import { mapGetters } from '../composables/utils'
import { ROUTER_CONSTS } from '../router/router.consts'
import { CONTEXT_CONSTS } from '../store/context/context.consts'
import AppHeaderUser from './app-header-user.component.vue'
import { EpbButton } from './shared/epb-button'

export default defineComponent({
  name: 'AppHeader',
  components: {
    AppHeaderUser,
    EpbButton,
  },
  setup() {
    const ctx = getCurrentInstance()

    const baseClass = 'epb-app-header'

    const { context } = mapGetters<ContextState>(ctx.proxy.$store, CONTEXT_CONSTS.moduleName, {
      context: CONTEXT_CONSTS.getters.context,
    })
    const title = computed<string>(() => {
      const messages = ctx.proxy.$epb.messages.app as AppMessages
      const { featureId, titleI18nKey } = ctx.proxy.$route.meta
      function getDomainMessage(message: object | string | undefined): string | undefined {
        return message instanceof Object ? message[context.value.domain] : message
      }
      return (
        getDomainMessage(messages.routes[titleI18nKey]) ??
        getDomainMessage(messages.features[featureId]) ??
        featureId
      )
    })

    function back(): void {
      if (window.history.length > 1) {
        ctx.proxy.$router.go(-1)
      } else {
        ctx.proxy.$router.push({
          ...ctx.proxy.$route,
          name: ROUTER_CONSTS.routes.home,
        })
      }
    }

    return {
      baseClass,
      title,
      back,
    }
  },
})
